<template>
  <div class="divide-y divide-bg space-y-6 -mt-6">
    <div v-for="(group,i) in sortedGroups" :key="i">
      <div v-show="group.id !== null"
           class="flex items-center pt-6 lg:pl-2 pr-1 mb-4
                  cursor-pointer
                  text-sm font-bold text-text"
           @click="$emit('toggleGroup',group)">
        <div class="mr-2 pl-2">{{ group.title }}</div>
        <div class="text-2xs leading-none">
          <font-awesome-icon
              :icon="`chevron-${group.dashboard_collapsed ? 'down':'up'}`"/>
        </div>
        <div class="ml-auto pr-5 lg:pr-5" :class="{'text-red': group.sum < 0}"
             v-html="displayGroupBalance(group.sum)"></div>
      </div>
      <TransitionCollapseHeight>
        <MyAccountsItemsRows
            v-show="!group.dashboard_collapsed"
            class="mt-4 text-text-gray rounded overflow-hidden"
            :class="group.id !== null ? 'accounts-row' : 'divide-y divide-bg'"
            :accounts="group.childs"
            @selectAcc="$emit('selectAcc',$event)"/>
      </TransitionCollapseHeight>
    </div>
  </div>
</template>

<script>
import MyAccountsItemsRows from "@/components/cabinet/Money/Dashboard/MyAccounts/MyAccountsItemsRows";
import {mapGetters} from "vuex";
import TransitionCollapseHeight from "@/components/transitions/TransitionCollapseHeight";

export default {
  name: "MyAccountsGroupedRows",
  components: {TransitionCollapseHeight, MyAccountsItemsRows},
  props: {
    groups: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('space', ['spaceCurrency']),
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    sortedGroups() {
      //apply this to null group be the first and filter empty groups
      return [...this.groups].sort((a, b) => {
        if (a.id === null) {
          return b.order - a.order
        }
        return a.order - b.order
      }).filter(i => i.childs.length !== 0);
    }
  },
  methods: {
    displayGroupBalance(balance) {
      let currency = this.spaceCurrency,
          formattedBalance = this.displayCurrencyValue(balance, currency, false),
          intPart = formattedBalance.split('.')[0],
          decimalPart = formattedBalance.split('.')[1];
      //splitting value to apply css rules
      return `${intPart}<span class="opacity-40">.${decimalPart}</span> <span class="text-text-secondary">${currency.symbol}</span>`
    },
  }
}
</script>

<style lang="scss">
.accounts-row {
  > div {
    &:nth-child(odd) {
      @apply rounded bg-highlight;
    }
  }
}
</style>